module.exports = __webpack_public_path__ + "static/media/opportunities.9baf0834.svg";